import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { hasCreditsTransition } from '@panel/commons/helpers';
import { withQuery } from '@panel/commons/core/themev2';
import { ModalBase, selectColor, sendTrackingInfo, getAvailableCreditsCount } from '@panel/commons';
import { userInfoSelectors } from '@panel/core/src/state/ducks/user';
import { AdSlot, DFPManager } from 'react-dfp';
import { sendCustomTrackingInfo } from '@panel/commons/lib/sendTrackingInfo';
import Drawer from '@panel/commons/lib/Drawer';
import ErrorScreen from '@panel/commons/lib/ErrorScreen/ErrorScreen';
import EndModal from '@panel/commons/lib/Modals/EndModal';
import UnreadLeadsModal from '@panel/commons/lib/Modals/UnreadLeadsModal';
import Loader from '@panel/commons/lib/SimpleLoader';
import LockedManualModal from '../Modals/LockedManualModal';
import { Modal } from '../Modals/ModalWrapper';
import EmptyState from '../EmptyState/EmptyState';
import EmptySearch from '../EmptyState/EmptySearch';
import MemoizedPosting from './Posting/Posting';
import ProductsButton from '../commons/ProductsButton';
import ProductsTable from '../commons/ProductsTable';
import { PostingsSelectors, PostingsOperations } from '../../../ducks/posting';
import { creditsSelectors } from '../../../ducks/credits';
import SkeletonPage from './Skeleton/SkeletonPage';
import Alert from '../Alert/Alert';
import { useLockedSoftAlert } from '../Alert/useLockedSoftAlert';
import { useLockedManualAlert } from '../Alert/useLockedManualAlert';
import Bar from './SearchBar/SearchBar';
import Filtro from '../Filtro/Filtro';
import ArchiveModal from '../Modals/ArchiveModal';
import PublishModal from '../Modals/PublishModal';
import TourModal from '../Modals/TourModal';
import UpdateResponsibleModal from '../Modals/UpdateResponsibleModal';
import Pagination from './Pagination/Pagination';
import { getConfigByCountry } from '../../../helpers/bannerConfig';
import Dashboard from './Dashboard/Dashboard';
import useUrlSearchParams from '../hooks/useUrlSearchParams';
import { FilterOperations, FilterSelectors } from '../../../ducks/filter';
import ProductsTableSkeleton from './Skeleton/ProductsTableSkeleton';
import { SuspendOperations, SuspendSelectors } from '../../../ducks/suspend';
import { UnreadLeadsMsgOperations, UnreadLeadsMsgSelectors } from '../../../ducks/unreadLeadsMsg';
import { ArchiveSelectors } from '../../../ducks/archive';

const PostingsListDesktop = ({
  postingsData,
  device,
  hasFilters,
  finishedAction,
  setFinishedAction,
  userCanEditPermissions,
  setShowTour,
  closeTourModal,
  showTourModal,
  page,
  setPage,
  limit,
  numberOfPostings,
  setShowTourModal,
  loadingAction,
  isDesktopSmall,
  getPostings,
  isVAPublisher,
  snackBarTextBuilder
}) => {
  const isBrasilSite = process.env.REACT_APP_BUILD_SITE.includes('BR');
  const isZPARSite = process.env.REACT_APP_BUILD_SITE.includes('AR');
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { resetPostingsQualityToExport } = PostingsOperations;
  const [menuOpenId, setMenuOpenId] = useState(null);
  const { postings } = postingsData;
  const [productsListDisplay, setProductsListDisplay] = useState(Cookies.get('tableCreditsOpen') === 'true');
  const { lockedSoft, lockedManual, publisherTypeId, publisherId, isIntegrator, isAssistant } = useSelector(
    userInfoSelectors.getuserInfoState
  );
  const { isLoading, recievedSuccessfulResponse: suspendRecievedSuccessfulResponse } = useSelector(
    SuspendSelectors.getSuspendState
  );
  const {
    showUnreadLeadsModal,
    sendUnreadLeadsMsgLoading,
    hasUnreadLeads,
    hasUnreadLeadsLoading,
    comesFromArchive
  } = useSelector(UnreadLeadsMsgSelectors.getUnreadLeadsMsgState);
  const { isLoading: archiveLoading, recievedSuccessfulResponse: archiveRecievedSuccessfulResponse } = useSelector(
    ArchiveSelectors.getArchiveState
  );
  const {
    postingCount,
    postingsQualityToExport,
    postingsQualityToExportIsLoading,
    postingsQualityToExportCompleted,
    postingsQualityToExportFailed
  } = useSelector(PostingsSelectors.getPostingsState);
  const { showLockedSoftAlert, closeLockedSoftAlert } = useLockedSoftAlert(lockedSoft);
  const { showLockedManualAlert } = useLockedManualAlert(lockedManual);
  const { credits, ...creditsState } = useSelector(creditsSelectors.getCreditsState);
  const { branchCredits, globalCredits } = credits;
  const [lockedManualModal, setLockedManualModal] = useState(false);
  const [bulkActionsModals, setBulkActionsModals] = useState({
    finish: { open: false, paidPlansIncluded: false, postingList: [] },
    publish: { open: false, postingList: [], publicationType: '', postingsInfoSelected: {} },
    archive: {
      open: false,
      postingList: [],
      includesOnlinePostings: false,
      particularNotFree: false,
      onlinePostingsList: []
    },
    responsible: { open: false, postingList: [] }
  });
  const adsConfig = getConfigByCountry();
  const [filterDrawer, setFilterDrawer] = useState(false);
  const [showWelcomeBanner, setShowBannerWelcome] = useState(true);
  const [enableUnreadLeadsModal, setEnableUnreadLeadsModal] = useState(false);
  const hasCredits = branchCredits && !!branchCredits[0].creditItems;
  const loading = (postingsData.isLoading && !postingsData.fetchError) || loadingAction;
  // Se lee cookie para validación de checkeos de usuarios de soporte:
  const isFromCRM = Cookies.get('crmSessionId');

  const showNewPanelAlert = device === 'desktop' && (showWelcomeBanner || isFromCRM);

  const selectedNumber = postings.filter(p => p.checked).length;

  const barMessageNumber = selectedNumber || postingCount;

  const renderBanner = !isDesktopSmall && device !== 'tablet';
  const onlineStates = ['WITHOUT_CREDIT', 'ONLINE', 'NEAR_END'];
  const showPerformanceAlert =
    postings.length > 0 &&
    postings.filter(
      p => p.stateAndDates[0] && p.stateAndDates[0].status && onlineStates.includes(p.stateAndDates[0].status)
    ).length > 4;

  useEffect(() => {
    if (showUnreadLeadsModal && (suspendRecievedSuccessfulResponse || archiveRecievedSuccessfulResponse)) {
      setEnableUnreadLeadsModal(showUnreadLeadsModal);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showUnreadLeadsModal, suspendRecievedSuccessfulResponse, archiveRecievedSuccessfulResponse]);

  // EFECTO PARA MOSTRAR SNACKBAR DE ÉXITO EN ACCIÓN DE FINALIZADO O PUBLICACIÓN DE POSTING
  useEffect(() => {
    return () => {
      // SANEAMIENTO DEL STATE QUE DISPARA EL EFECTO
      setFinishedAction({ postingId: '', action: '', result: '', isParticularNotFree: false });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finishedAction.result]);

  useEffect(() => {
    if (
      (postingsQualityToExportCompleted && postingsQualityToExport.postings.length > 0) ||
      postingsQualityToExportFailed
    ) {
      setFinishedAction({
        postingId: '',
        action: 'downloadPostingsQuality',
        result: postingsQualityToExportFailed ? 'ERROR' : 'SUCCESS',
        component: snackBarTextBuilder(
          'downloadPostingsQuality',
          postingsQualityToExportFailed ? 'ERROR' : 'SUCCESS',
          false,
          null
        ),
        keepOpen: false
      });
      dispatch(resetPostingsQualityToExport());
    }
    if (postingsQualityToExportCompleted && postingsQualityToExport.postings.length === 0) {
      setFinishedAction({
        postingId: '',
        action: 'downloadPostingsQuality',
        result: 'INFO',
        component: t('panel.quality.generalData.downloadingData.notData'),
        keepOpen: false
      });
      dispatch(resetPostingsQualityToExport());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingsQualityToExportCompleted, postingsQualityToExportFailed]);

  useEffect(() => {
    if (publisherId) {
      DFPManager.setTargetingArguments({ idempresa: publisherId });
      DFPManager.load();
    }
  }, [publisherId]);

  useEffect(() => {
    if (lockedManual) {
      setLockedManualModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lockedManual]);

  useEffect(() => {
    /**
     *  Se valida si hay postings online y luego se consume servicio para conocer
     *  si alguno de esos avisos online tiene consultas sin responder.
     */
    if (bulkActionsModals.archive.includesOnlinePostings) {
      dispatch(UnreadLeadsMsgOperations.getUnreadLeads(bulkActionsModals.archive.onlinePostingsList.join(',')));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkActionsModals.archive.open]);

  useEffect(() => {
    // Se consume servicio para conocer si alguno de los avisos tiene consultas sin responder.
    if (bulkActionsModals && bulkActionsModals.finish.open) {
      dispatch(UnreadLeadsMsgOperations.getUnreadLeads(bulkActionsModals.finish.postingList.join(',')));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkActionsModals.finish.open]);

  const [postingUsedInTour, setPostingUsedInTour] = useState('');

  const getTourButton = () => {
    if (!postingUsedInTour) return null;
    return t('panel.avisos.tour.modal.open');
  };

  const hasDrawer = device === 'tablet' || isDesktopSmall;

  useEffect(() => {
    const noOnlinePostings = !postings.some(
      p => p.stateAndDates[0] && p.stateAndDates[0].status && onlineStates.includes(p.stateAndDates[0].status)
    );
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < postings.length; i++) {
      const status = postings[i].stateAndDates[0] && postings[i].stateAndDates[0].status;
      if (onlineStates.includes(status) || noOnlinePostings) {
        setPostingUsedInTour(postings[i].postingId);
        break;
      }
    }
  }, [onlineStates, postings]);

  useEffect(() => {
    const hideWelcomeBannerCookie = Cookies.get('hideWelcomeBanner');
    if (hideWelcomeBannerCookie) {
      setShowBannerWelcome(false);
    } else Cookies.set('hideWelcomeBanner', true, { expires: 999 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [showBannerUnifiedPanel, setShowBannerUnifiedPanel] = useState(false);
  const { cleanPartialUrlFilters } = useUrlSearchParams();
  const filtersData = useSelector(FilterSelectors.getFiltersState);
  const filtersCriteria = filtersData.searchCriteria;
  const hasCreditFromUnifiedPanel = hasCreditsTransition(branchCredits, globalCredits);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    // Se valida que tenga el filtro publicationPlan aplicado:
    const publicationPlanFilterApplied =
      params &&
      params
        .toString()
        .split('&')
        .filter(item => item.split('=')[0] === 'publicationPlan')[0];

    const hasPlanFreeFilterApplied =
      publicationPlanFilterApplied && publicationPlanFilterApplied.split('=')[1] === 'FREE';

    // Se valida que el filtro publicationPlan aplicado no sea 'FREE' y que tenga créditos de transición para mostrar el banner con el CTA para aplicar el filtro de 'FREE':
    const isEnadledToShowBannerUnifiedPanels =
      !isVAPublisher && hasCreditFromUnifiedPanel && publicationPlanFilterApplied && !hasPlanFreeFilterApplied;

    setShowBannerUnifiedPanel(isEnadledToShowBannerUnifiedPanels);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersCriteria, hasCreditFromUnifiedPanel]);

  const handleClickBannerVA = () => {
    dispatch(FilterOperations.partialResetFilters('publicationPlan', { id: 'FREE', displayName: 'FREE' }));
    cleanPartialUrlFilters('FREE', 'publicationPlan');
  };

  const listOfPostingSelected = () => {
    const filteredPostings = postingsData.postings.filter(p =>
      bulkActionsModals.finish.postingList.includes(p.postingId)
    );
    return filteredPostings.every(currentValue => currentValue.isDuplicate);
  };

  const onCloseTourInModal = () => {
    closeTourModal();
    if (device === 'desktop') {
      sendTrackingInfo('Panel', 'Mis avisos', 'Tour virtual-Comienza el recorrido_Salir');
    }
  };

  const toogleTableCredits = () => {
    Cookies.set('tableCreditsOpen', !productsListDisplay, {
      expires: 999
    });
    setProductsListDisplay(!productsListDisplay);
  };

  /**
   * @param {boolean} hasError
   * @returns Muestra lista de creditos disponibles. Evalua si hay error en el servicio, muestra mensaje de error.
   * En caso de no tener creditos disponibles muestra mensaje de no creditos.
   */

  const getProductsListDisplay = hasError => {
    if (!hasError && !hasCredits) {
      return <NoCredits>{t('panel.available.products.noCredits')}</NoCredits>;
    }
    return (
      <ProductsTable
        branchCredits={branchCredits}
        globalCredits={globalCredits && globalCredits.creditItems}
        hasCreditFromUnifiedPanel={hasCreditFromUnifiedPanel}
        isDesktop
        hasError={hasError}
      />
    );
  };

  return (
    <Container device={device} isBrasilSite={isBrasilSite}>
      {showTourModal && postingUsedInTour && device === 'desktop' && (
        <Modal>
          <ModalBase
            openModal={showTourModal}
            onClose={onCloseTourInModal}
            withoutCloseButton
            width='400px'
            height='480px'
          >
            <TourModal
              setShowTour={setShowTour}
              onClose={closeTourModal}
              onCloseTourInModal={onCloseTourInModal}
              title={t('panel.avisos.tour.modal.title')}
              textInfo={t('panel.avisos.tour.modal.body')}
              textPrimaryCTA={t('panel.avisos.tour.modal.cta')}
              withSkiptCTA
            />
          </ModalBase>
        </Modal>
      )}
      {lockedManualModal && (
        <Modal>
          <ModalBase
            openModal={lockedManualModal}
            onClose={() => setLockedManualModal(false)}
            width={isZPARSite ? '496px' : '400px'}
            height={isZPARSite ? 'fit-content' : '358px'}
          >
            <LockedManualModal onClose={() => setLockedManualModal(false)} isZPARSite={isZPARSite} />
          </ModalBase>
        </Modal>
      )}
      {bulkActionsModals.finish.open && (
        <Modal>
          <ModalBase
            openModal={bulkActionsModals.finish}
            onClose={() => {
              setBulkActionsModals({
                ...bulkActionsModals,
                finish: { open: false, paidPlansIncluded: false, postingList: [] }
              });
              sendCustomTrackingInfo({
                event: 'trackEvent',
                eventCategory: 'Panel',
                eventAction: 'Mis avisos',
                eventLabel: 'Finalizar Aviso-finalizar_cerrar'
              });
            }}
            isLoading={postingsData.loadingFinishReason || isLoading || hasUnreadLeadsLoading}
            withoutOutsideClose
          >
            <EndModal
              hasDuplicate={listOfPostingSelected()}
              device={device}
              onClose={() =>
                setBulkActionsModals({
                  ...bulkActionsModals,
                  finish: { open: false, paidPlansIncluded: false, postingList: [] }
                })
              }
              postingId={null}
              publisherTypeId={publisherTypeId}
              publisherId={publisherId}
              bulkIds={bulkActionsModals.finish.postingList}
              particularNotFree={bulkActionsModals.finish.paidPlansIncluded && publisherTypeId === '1'}
              finishReason={postingsData.finishReason}
              SuspendOperations={SuspendOperations}
              UnreadLeadsMsgOperations={UnreadLeadsMsgOperations}
              hasUnreadLeads={hasUnreadLeads}
            />
          </ModalBase>
        </Modal>
      )}
      {enableUnreadLeadsModal && (
        <Modal>
          <ModalBase
            openModal={enableUnreadLeadsModal}
            onClose={() => {
              dispatch(UnreadLeadsMsgOperations.setShowUnreadLeadsModal(false, [], false));
              setEnableUnreadLeadsModal(false);
              sendCustomTrackingInfo({
                event: 'trackEvent',
                eventCategory: 'Panel',
                eventAction: 'Mis avisos',
                eventLabel: `${comesFromArchive ? 'Archivar' : 'Finalizar'} Aviso-enviar_cerrar`
              });
            }}
            isLoading={sendUnreadLeadsMsgLoading}
            withoutOutsideClose
          >
            <UnreadLeadsModal
              device={device}
              onClose={() => {
                dispatch(UnreadLeadsMsgOperations.setShowUnreadLeadsModal(false, [], false));
                setEnableUnreadLeadsModal(false);
              }}
              publisherTypeId={publisherTypeId}
              publisherId={publisherId}
              UnreadLeadsMsgOperations={UnreadLeadsMsgOperations.sendUnreadLeadsMessagge}
              UnreadLeadsMsgSelectors={UnreadLeadsMsgSelectors.getUnreadLeadsMsgState}
              onlinePostingsList={bulkActionsModals.archive.onlinePostingsList}
              comesFromArchive={comesFromArchive}
              postings={postings}
            />
          </ModalBase>
        </Modal>
      )}
      {bulkActionsModals.archive.open && (
        <Modal>
          <ModalBase
            openModal={bulkActionsModals.archive}
            onClose={() => {
              setBulkActionsModals({
                ...bulkActionsModals,
                archive: {
                  open: false,
                  paidPlansIncluded: false,
                  postingList: [],
                  includesOnlinePostings: false,
                  particularNotFree: false
                }
              });
              sendCustomTrackingInfo({
                event: 'trackEvent',
                eventCategory: 'Panel',
                eventAction: 'Mis avisos',
                eventLabel: 'Archivar Aviso-archivar_cerrar'
              });
            }}
            isLoading={postingsData.loadingFinishReason || hasUnreadLeadsLoading || archiveLoading}
          >
            <ArchiveModal
              isOnline={bulkActionsModals.archive.includesOnlinePostings}
              particularNotFree={bulkActionsModals.archive.particularNotFree}
              device={device}
              onClose={() =>
                setBulkActionsModals({
                  ...bulkActionsModals,
                  archive: {
                    open: false,
                    postingList: [],
                    includesOnlinePostings: false,
                    particularNotFree: false,
                    onlinePostingsList: bulkActionsModals.archive.onlinePostingsList
                  }
                })
              }
              postingIds={bulkActionsModals.archive.postingList}
              publisherTypeId={publisherTypeId}
              finishReason={postingsData.finishReason}
              postings={postings}
              hasUnreadLeads={hasUnreadLeads}
            />
          </ModalBase>
        </Modal>
      )}
      {bulkActionsModals.publish.open && (
        <Modal>
          <ModalBase
            openModal={bulkActionsModals.publish}
            onClose={() =>
              setBulkActionsModals({
                ...bulkActionsModals,
                publish: { open: false, postingList: [], publicationType: '' }
              })
            }
            width='400px'
            height='fit-content'
            isLoading={creditsState.loading}
          >
            <PublishModal
              device={device}
              onClose={() =>
                setBulkActionsModals({
                  ...bulkActionsModals,
                  publish: { open: false, postingList: [], publicationType: '' }
                })
              }
              postings={bulkActionsModals.publish.postingList}
              publicationType={bulkActionsModals.publish.publicationType}
              postingsInfoSelected={bulkActionsModals.publish.postingsInfoSelected}
              postingList={postings}
              isIntegrator={isIntegrator}
              publisherTypeId={publisherTypeId}
            />
          </ModalBase>
        </Modal>
      )}
      {bulkActionsModals.responsible.open && (
        <Modal>
          <ModalBase
            openModal={bulkActionsModals.responsible}
            onClose={() =>
              setBulkActionsModals({
                ...bulkActionsModals,
                responsible: { open: false, postingList: [] }
              })
            }
            width='512px'
            height='fit-content'
          >
            <UpdateResponsibleModal
              onClose={() =>
                setBulkActionsModals({
                  ...bulkActionsModals,
                  responsible: { open: false, postingList: [] }
                })
              }
              postings={bulkActionsModals.responsible.postingList}
              isIntegrator={isIntegrator}
            />
          </ModalBase>
        </Modal>
      )}
      <PostingsHeader>
        {device === 'tablet' && <ListTitle>{t('panel.header.title.postings')}</ListTitle>}
        {showNewPanelAlert && (
          <AlertContainer>
            <Alert
              optionalButtonText={getTourButton()}
              optionalButtonDataPanel='panel-alert-newPanel-openTour'
              onOptionalButtonPress={postingUsedInTour ? () => setShowTourModal(true) : null}
              optionalButtonDataLayer={{
                event: 'trackEvent',
                eventCategory: 'Panel',
                eventAction: 'Mis avisos',
                eventLabel: 'Tour virtual-Iniciar tour virtual'
              }}
              isFromCRM={isFromCRM}
              isNeutral
            >
              {t('panel.avisos.alert.newPanel')}
            </Alert>
          </AlertContainer>
        )}
        {showLockedManualAlert && (
          <AlertContainer>
            <Alert dataLayerText='Cuenta bloqueada'>{t('panel.avisos.alert.lockedManual')}</Alert>
          </AlertContainer>
        )}
        {showLockedSoftAlert && (
          <AlertContainer>
            <Alert onClose={closeLockedSoftAlert} dataLayerText='Saldo deudor'>
              {t('panel.avisos.alert.lockedSoft')}
            </Alert>
          </AlertContainer>
        )}
        {device === 'desktop' && (
          <Dashboard
            showPerformanceAlert={showPerformanceAlert}
            postingsError={postingsData.fetchError}
            isIntegrator={isIntegrator}
            isParticular={publisherTypeId === '1'}
          />
        )}
      </PostingsHeader>
      <Wrapper>
        {!postingsData.fetchError && (
          <>
            <FilterContainer device={device} isDesktopSmall={isDesktopSmall}>
              <Filtro isDesktop />
            </FilterContainer>
            <PostingsListContainer device={device} isDesktopSmall={isDesktopSmall}>
              <CreditsWrapper device={device}>
                <ProductsButton
                  handleClick={() => {
                    toogleTableCredits();
                    sendTrackingInfo('Panel', 'Mis avisos', 'Productos disponibles-Desplegar');
                  }}
                  isTableOpen={productsListDisplay && !creditsState.loading}
                  availableCount={getAvailableCreditsCount(branchCredits, globalCredits)}
                  isLoading={creditsState.loading}
                  hasError={creditsState.fetchError}
                />

                {creditsState.loading && <ProductsTableSkeleton device={device} isTableOpen={productsListDisplay} />}

                {productsListDisplay && !creditsState.loading ? (
                  <>{getProductsListDisplay(creditsState.fetchError)}</>
                ) : null}
              </CreditsWrapper>
              <BarWrapper device={device}>
                <Bar
                  bulkActionsModals={bulkActionsModals}
                  setBulkActionsModals={setBulkActionsModals}
                  postings={postings}
                  device={isDesktopSmall ? 'tablet' : device}
                  barMessageNumber={barMessageNumber}
                  selectedNumber={selectedNumber}
                  setFilterDrawer={setFilterDrawer}
                  isAssistant={isAssistant}
                  userCanEditResponsible={userCanEditPermissions}
                />
              </BarWrapper>
              {showBannerUnifiedPanel && (
                <AlertContainer setMargin={device === 'tablet' ? '0 18px 18px' : '-12px 0 22px'}>
                  <Alert
                    onClose={handleClickBannerVA}
                    buttonText={t('panel.posting.banner.filters_UnifiedPanels.cta')}
                    isWarning
                  >
                    {t('panel.posting.banner.filters_UnifiedPanels')}
                  </Alert>
                </AlertContainer>
              )}

              {postingsQualityToExportIsLoading && (
                <LoaderWrapper>
                  <Loader />
                  <LoaderTexte>{t('panel.quality.generalData.downloadingData.loading')}</LoaderTexte>
                </LoaderWrapper>
              )}

              <PostingsWrapper device={device}>
                {!postingsData.fetchError &&
                  postingsData.postings.length > 0 &&
                  !postingsQualityToExportIsLoading &&
                  !loading &&
                  postings.map(p => (
                    // Pasar a MemoizedPosting todas las props que deban disparar render para comparación entre prevProps y nextProps (sólo shallow compare)
                    <MemoizedPosting
                      finishedAction={finishedAction.postingId === p.postingId ? finishedAction.action : null}
                      finishedActionResult={finishedAction.postingId === p.postingId ? finishedAction.result : null}
                      postingStatus={p.stateAndDates[0].status}
                      loadingLeads={p.loadingLeads}
                      loadingQuality={p.loadingQuality}
                      loadingVisits={p.loadingVisits}
                      loadingPerformanceStatus={p.loadingPerformanceStatus}
                      device={device}
                      key={p.postingId}
                      posting={p}
                      userCanEditPermissions={userCanEditPermissions}
                      checkedPosting={p.checked}
                      usedForTour={p.postingId === postingUsedInTour}
                      socialAdsReport={p.socialAdsReport}
                      isParticular={publisherTypeId === '1'}
                      isIntegrator={isIntegrator}
                      setFinishedAction={setFinishedAction}
                      isAssistant={isAssistant}
                      finishReason={postingsData.finishReason}
                      loadingFinishReason={postingsData.loadingFinishReason}
                      loadingCredits={creditsState.loading}
                      setMenuOpenId={setMenuOpenId}
                      menuOpenId={menuOpenId}
                    />
                  ))}
                {loading && <SkeletonPage device={device} />}
                {!postingsData.isLoading &&
                  !postingsData.postings.length &&
                  !postingsData.fetchError &&
                  !hasFilters && <EmptyState />}
                {!postingsData.isLoading && !postingsData.postings.length && !postingsData.fetchError && hasFilters && (
                  <EmptySearch />
                )}
                {postingsData.postings.length > 0 && numberOfPostings > limit && (
                  <Pagination page={page} setPage={setPage} limit={limit} numberOfPostings={numberOfPostings} />
                )}
              </PostingsWrapper>
            </PostingsListContainer>
          </>
        )}
        {postingsData.fetchError && <ErrorScreen isDesktop handleOnclick={getPostings} />}
      </Wrapper>
      {renderBanner && (
        <div className='banner-container'>
          {adsConfig && (
            <AdSlot sizes={adsConfig.sizes} dfpNetworkId={adsConfig.dfpNetworkId} adUnit={adsConfig.adUnit} />
          )}
        </div>
      )}
      {filterDrawer && hasDrawer && (
        <Drawer isOpen={filterDrawer} coverAll>
          <Filtro isTablet onClose={() => setFilterDrawer(false)} />
        </Drawer>
      )}
    </Container>
  );
};

const PostingsWrapper = styled.div`
  ${({ device }) =>
    device !== 'tablet' &&
    css`
      > div {
        margin-bottom: 24px;
        &:last-of-type {
          margin-bottom: 0px;
        }
      }
    `}
`;

const BarWrapper = styled.div`
  ${({ device }) =>
    device === 'tablet' &&
    css`
      padding: 0px 18px;
    `}
`;

const LoaderTexte = styled.div`
  background-color: ${selectColor('white')};
  padding: 8px;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1480px;
  padding: 30px 10px 30px 10px;
  margin: auto;
  white-space: normal;
  .banner-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  ${withQuery.lg.down()} {
    margin-top: ${({ isBrasilSite }) => (isBrasilSite ? '75' : '45')}px;
  }
`;

const FilterContainer = styled.div`
  display: ${({ device, isDesktopSmall }) => (device === 'tablet' || isDesktopSmall ? 'none' : 'flex')};
  background-color: ${selectColor('grayLight')};
  height: fit-content;
  width: 300px;
  margin-right: 32px;
  border-radius: 8px;
  overflow: hidden;
`;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 0 10px;
  margin-bottom: 50px;
`;

const PostingsListContainer = styled.div`
  width: ${({ device, isDesktopSmall }) => (device === 'tablet' || isDesktopSmall ? '100' : '77')}%;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      width: 100vw;
      overflow: hidden;
      position: absolute;
      left: 0;
    `}
`;

const PostingsHeader = styled.div`
  width: 100%;
  max-width: 1480px;
  padding: 0 10px;
`;

const NoCredits = styled.div`
  color: ${selectColor('grayDark')};
  font-size: 14px;
  border: 1px solid ${selectColor('grayMediumLight')};
  border-radius: 0px 0px 6px 6px;
  padding: 16px 0px 16px 30px;
`;

const AlertContainer = styled.div`
  margin: ${({ setMargin }) => setMargin || '0 0 18px'};
`;

const ListTitle = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 51px;
`;

const CreditsWrapper = styled.div`
  margin-bottom: 12px;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      padding: 0px 18px;
    `}
`;

const LoaderWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgb(256, 256, 256, 0.6);
  z-index: 200;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export default PostingsListDesktop;
